import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_ctx.buttonClass),
    type: _ctx.type,
    disabled: _ctx.loading || _ctx.disabled
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _cache[0] || (_cache[0] = _createTextVNode("Button"))
    ])
  ], 10, _hoisted_1))
}